import { render, staticRenderFns } from "./LicenseCheck.vue?vue&type=template&id=92466308&scoped=true"
import script from "./LicenseCheck.vue?vue&type=script&lang=js"
export * from "./LicenseCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92466308",
  null
  
)

export default component.exports